
import {ShCompanySearch} from 'components/search-dropdown'


export default {
  components: {
    ShCompanySearch
  },
  emits: ['submit'],
  data() {
    return {
      name: undefined,
      name_valid: false,
      shared_company_id: undefined,
      email_domain: undefined,
      email_domain_valid: false
    }
  },
  computed: {
    can_submit() {
      return this.name_valid && this.email_domain_valid && !!this.shared_company_id
    }
  },
  methods: {
    open(){
      this.name = undefined
      this.name_valid = false
      this.shc_shared_company_id = undefined
      this.email_domain = undefined
      this.email_domain_valid = true
      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.i_name.focus())
    },
    close() {
      this.$refs.modal.close()
      
    },
    submit() {
      this.close()
      this.$emit('submit', {
        name: this.name, 
        shared_company_id: this.shared_company_id, 
        email_domain: this.email_domain
      })
    }
  }
}
